module.exports = __webpack_public_path__ + "static/img/9areaA_11.62faa34.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/9areaA_11.png
// module id = 1062
// module chunks = 1